var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourlyRateProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#A47632",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 23.75c-.5-.125-1-.375-1.375-.75-.375-.125-.5-.5-.5-.75s.125-.625.375-.75c.375-.25.75-.5 1.125-.375.75 0 1.375.375 1.75.875l1.125-1.5c-.375-.375-.75-.625-1.125-.875s-.875-.375-1.375-.375V17.5h-1.5v1.75c-.625.125-1.25.5-1.75 1-.5.625-.875 1.375-.75 2.125 0 .75.25 1.5.75 2 .625.625 1.5 1 2.25 1.375.375.125.875.375 1.25.625.25.25.375.625.375 1s-.125.75-.375 1.125c-.375.375-.875.5-1.25.5-.5 0-1.125-.125-1.5-.5a3.804 3.804 0 0 1-1-1L21 28.875c.375.5.75.875 1.25 1.25.625.375 1.375.75 2.125.75V32.5h1.375v-1.875c.75-.125 1.375-.5 1.875-1 .625-.625 1-1.625 1-2.5 0-.75-.25-1.625-.875-2.125-.625-.625-1.25-1-2-1.25zM25 15c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 18.625c-4.75 0-8.625-3.875-8.625-8.625S20.25 16.375 25 16.375 33.625 20.25 33.625 25 29.75 33.625 25 33.625z",
    fill: "#A47632"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourlyRateProfile);
export default __webpack_public_path__ + "static/media/hourlyRate-profile.b7b3c2d23e70c6bc950c70fa88fbbc65.svg";
export { ForwardRef as ReactComponent };